import React from 'react'
import Helmet from 'react-helmet'
import '../styles/index.css'
import Logo from '../../components/Logo'
import Footer from '../../components/Footer'
import Modal from 'pubweb-react-components/dist/components/Modal/Modal'
import heroImageLg from '../../images/quiz/ch-him2-lp-hero-quiz.jpg'
import Quiz from '../../components/Quiz'
import IndexPageStyles from './IndexPage.styled'
import { trackVWO } from '../../utils/analytics'

export class IndexPage extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      quizModalVisible: false,
    }
    this.toggleModal = this.toggleModal.bind(this)
  }

  toggleModal() {
    let modalVisibility = this.state.quizModalVisible
    this.setState({
      quizModalVisible: !modalVisibility,
    })
  }

  render() {
    return (
      <div>
        <IndexPageStyles>
          <Helmet
            title="Quiz: Find A Home That Fits Your Style | Clayton Homes"
            onChangeClientState={() => {
              trackVWO(70507)
            }}
            meta={[
              {
                name: 'viewport',
                content:
                  'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no',
              },
              { name: 'referrer', content: 'always' },
              { charset: 'UTF-8' },
              { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
            ]}
          >
            {/* <!-- Osano Privacy Script --> */}
            <script src="https://cmp.osano.com/AzZd2RTbLigwQ5KJW/fc5c932e-d137-4fcf-ba8f-d9531da1e2ef/osano.js" />
            {/* <!-- End Osano Privacy Script --> */}

            <link
              rel="icon"
              type="image/x-icon"
              href="https://www.claytonhomes.com/images/favicon.ico?v=1"
            />
            <link
              rel="shortcut icon"
              type="image/png"
              href="https://www.claytonhomes.com/images/favicon.png?v=1"
            />
            <script
              defer="defer"
              type="text/javascript"
              data-id="ccpa-banner"
              data-first-link-text="Privacy Policy"
              data-first-link-href="https://www.claytonhomes.com/privacy/"
              src="https://privacy.claytonhomes.com/ccpa/v5/index.min.js"
            />
            <link
              rel="canonical"
              href="https://www.claytonhomes.com/pages/quiz/"
            />
            <meta name="robots" content="noindex, nofollow" />
          </Helmet>
          <section
            className="topCon"
            style={{ backgroundImage: `url(${heroImageLg})` }}
          >
            <div className="darken" />
            <Logo />
            <div className="content-quiz">
              <h2 className="header-quiz header">
                Five questions to find the perfect modern home.
              </h2>
              <button className="button button-quiz" onClick={this.toggleModal}>
                Start Quiz
              </button>
            </div>
          </section>
          <section className="middleCon">
            <div className="middle-section built">
              <span className="img" />
              <h3 className="middle-section-header">Built indoors.</h3>
              <p className="middle-section-content">
                Our advanced, climate-controlled facilities ensure homes built
                with quality materials, less waste and minimal weather delays.
              </p>
            </div>
            <div className="middle-section prefab">
              <span className="img" />
              <h3 className="middle-section-header">
                Not Prefab. Prefabulous.
              </h3>
              <p className="middle-section-content">
                Clayton Homes offer more style for the money, from wide open
                floor plans and customizable gourmet kitchens to luxurious
                bathrooms and high-end finishes.
              </p>
            </div>
            <div className="middle-section buy">
              <span className="img" />
              <h3 className="middle-section-header">
                Bye-bye buyer’s remorse.
              </h3>
              <p className="middle-section-content">
                Our digital tools and helpful home consultants make it easy to
                dream, discover and decide on the right home for you.
              </p>
            </div>
          </section>
          <Footer />
          {this.state.quizModalVisible ? (
            <Modal
              modalSize="small"
              isVisible={this.state.quizModalVisible}
              onCloseClicked={this.toggleModal}
            >
              <Quiz exitModal={this.toggleModal} />
            </Modal>
          ) : null}
        </IndexPageStyles>
      </div>
    )
  }
}

export default IndexPage
